const createDdpScheduleLink = (href) => {
    const joinChar = href?.includes('?') ? '&' : '?';
    const salesTabParam = 'dealerdetailstabs=service#service';
    return `${href}${joinChar}${salesTabParam}`;
};

export default createDdpScheduleLink;
